var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrowLightgrayMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74992 10.75C10.1015 10.75 10.414 10.6328 10.6484 10.3984L18.1484 2.89844C18.6562 2.42969 18.6562 1.60938 18.1484 1.14062C17.6796 0.632812 16.8593 0.632812 16.3905 1.14062L9.74992 7.74219L3.14836 1.14062C2.67961 0.632812 1.8593 0.632812 1.39055 1.14062C0.882737 1.60938 0.882737 2.42969 1.39055 2.89844L8.89055 10.3984C9.12492 10.6328 9.43742 10.75 9.74992 10.75Z",
    fill: "#5C5E69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowLightgrayMedium);
export default __webpack_public_path__ + "static/media/up-arrow-lightgray-medium.866338ea2ba4ed477581aaeee5e0ae5c.svg";
export { ForwardRef as ReactComponent };